import { render, staticRenderFns } from "./CapturaVoz.vue?vue&type=template&id=47daddd6"
import script from "./CapturaVoz.vue?vue&type=script&lang=js"
export * from "./CapturaVoz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports